import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { BulkUpdateStatusByIdsRequestDto } from '../../../api/dto/plan-benefit-override-rules.dto'
import { bulkUpdateStatusByIds } from '../../../api/plan-benefit-override-rules-api'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

export function useBulkUpdateStatusByIds() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: BulkUpdateStatusByIdsRequestDto) =>
      bulkUpdateStatusByIds(body),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
